import axios from 'axios'
import { Technology } from 'models'

export const getTechnologies = async (searchTerm?: string) => {
	let url = '/technology'
	if (searchTerm) {
		url += `?search=${encodeURIComponent(searchTerm)}`
	}
	const response = await axios.get(url)
	return response.data
}
export const createTechnology = async (technologyData: Technology) => {
	try {
		const response = await axios.post(`/technology`, {
			...technologyData
		})
		return response.data
	} catch (error: any) {
		return error.response
	}
}

export const updateTechnology = async (technologyData: any) => {
	try {
		const { id, ...rest } = technologyData
		const response = await axios.put(`/technology/${id}`, {
			...rest
		})
		return response.data
	} catch (error: any) {
		return error.response
	}
}

export const deleteTechnology = async (technologyId: string) => {
	try {
		const response = await axios.delete(`/technology/${technologyId}`)
		return response.data
	} catch (error: any) {
		return error.response
	}
}
